import * as React from 'react';

import { ExtractedTableModal } from 'modules/extractedTables/ExtractedTableModal';
import { useSelectedTable } from 'modules/extractedTables/SelectedTableContext';

/**
 * This is a convenience wrapper over the ExtractedTableModal so it can access context hooks
 * without having to raise context higher than the file the providers are defined in
 */
export const ExtractedTableModalContainer = ({
  fileLink,
}: {
  fileLink?: React.ReactNode;
}) => {
  const {
    selectedTableUrl,
    setSelectedTableUrl,
    selectedExtractedTable,
    rawTableData,
    isSelectedTableFetching,
    hasTableDataError,
  } = useSelectedTable();

  return (
    <ExtractedTableModal
      rawTableData={rawTableData}
      tableJsonData={selectedExtractedTable ?? null}
      isLoading={isSelectedTableFetching}
      hasTableDataError={hasTableDataError}
      isExtractedTableModalOpen={!!selectedTableUrl}
      onCloseExtractedTableModal={() => setSelectedTableUrl(null)}
      fileLink={fileLink}
    />
  );
};
